<template>
  <div class="hreg--videoinfo align-items-center">
    <div class="hreg--info-dot">
      <i class="mdi mdi-information mdi-48px"></i>
    </div>
    <div class="hreg--info-body">
      <div v-if="showGlnInfo">
        {{ $t('furtherInformation.person.accessGln') }}
        {{ associationName }}
        {{ infoBodyText2 }}
        <span v-if="orderLink !== undefined" class="text-warning">
        <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" type="button" :href="glnInfoUrl">{{ orderLink }}</a>
        <span style="color: #343A3F;" v-if="language === 'it'">{{$t('furtherInformation.slash')}}</span>
        <a v-if="language === 'it'" class="text-primary" target="_blank" rel="noreferrer noopener nofollow" type="button" :href="glnInfoUrlFr">{{ orderLinkFr }}</a>
      </span>
      </div>
      <div v-if="showEmailInfo">
        <p>
          {{ $t("emailForm.infoTextMail") }}
        </p>
        <div v-if="!showTeamIdText">
          <p>
            {{ $t("emailForm.infoTextPleaseConsider") }}
          </p>
          <ul class="d--no-indent">
            <li>{{ $t("emailForm.infoTextFullName") }}</li>
            <li>{{ $t("emailForm.infoTextFirstName") }}</li>
            <li>{{ $t("emailForm.infoTextFantasyName") }}</li>
          </ul>
        </div>
      </div>
      <div v-if="showPraxisInfo">
          {{ $t("emailForm.praxisSoftwareInfo") }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  infoBodyText1: {
    type: String,
  },
  infoBodyText2: {
    type: String,
  },
  associationName: {
    type: String,
  },
  orderLink: {
    type: String,
  },
  orderLinkFr: {
    type: String,
  },
  glnInfoUrl: {
    type: String,
  },
  glnInfoUrlFr: {
    type: String,
  },
  showEmailInfo: {
    type: Boolean,
  },
  showGlnInfo: {
    type: Boolean,
  },
  showPraxisInfo: {
    type: Boolean,
  },
  showTeamIdText: {
    type: Boolean,
  },
  language: { 
    type: String,
  }
});
</script>

<style scoped>
.styling{
  align-items: center;
}
</style>
